__turbopack_context__.v({
  "SCmsImageForAssetRefDesktop": "_7yrKkW_SCmsImageForAssetRefDesktop",
  "SCmsImageForAssetRefMobile": "_7yrKkW_SCmsImageForAssetRefMobile",
  "SSponsor": "_7yrKkW_SSponsor",
  "STrackingPixel": "_7yrKkW_STrackingPixel",
  "isSticky": "_7yrKkW_isSticky",
});
